module.exports = __webpack_public_path__ + "img/item3.eba960f2.png";